import React from 'react';
import { useState, useEffect } from 'react';
import './pen-assignment.css';
import CentumButton from '../../../../../Button/CentumButton';
import Table, { IColum } from '../../../../../Table/Table';
import CentumInput from '../../../../../Input/CentumInput';
import CentumSelect from '../../../../../Select/CentumSelect';
import PortableWindow from 'components/MainPage/dcs/centumvp/components/PortableWindow/PortableWindow';
import { group } from 'console';
import { SetParamBaseCentum } from 'components/hmilib/hmiclientbase';
import { rootStore } from 'store';

interface IPen {
    Top: number;
    Left: number;
    title: string;
    group: any;
    fullGroup: any;
    parentID: string;
    // refresh: boolean,
    OnClose: (blockInterval?: boolean) => void;
    RefreshPen: () => void;
    CallbackRender?: (id: string) => void;
    OnCollapse?: (index: string, height: number, width: number) => void;
}

function PenAssigment(props: IPen) {
    const tableHeader: IColum[] = [
        {
            type: 'number',
            width: '20px',
            label: '',
            idCol: 'ColNumber',
            action: false
        },
        {
            type: 'text',
            width: '220px',
            label: 'Block',
            idCol: 'Block',
            action: false
        },
        {
            type: 'text',
            width: '220px',
            label: 'Collected',
            idCol: 'Collected',
            action: false
        },
        {
            type: 'select',
            width: '110px',
            label: 'Set Upper/lower',
            idCol: 'SetUpperLower',
            action: false
        },
        {
            type: 'text',
            width: '140px',
            label: 'Lower',
            idCol: 'Lower',
            action: false
        },
        {
            type: 'text',
            width: '140px',
            label: 'Upper',
            idCol: 'Upper',
            action: false
        }
    ];

    const blockOpt = [
        '1: Rotary 01min. 2.00:00:00',
        '2: Rotary 01min. 2.00:00:00',
        '3: Rotary 01min. 2.00:00:00',
        '4: Rotary 01min. 2.00:00:00',
        '5: Rotary 10sec. 0.08:00:00',
        '6: Rotary 10sec. 0.08:00:00',
        '7: Rotary 01min. 2.00:00:00',
        '8: Rotary 10sec. 0.08:00:00',
        '9: Rotary 10sec. 0.08:00:00',
        '10: Rotary 10sec. 0.08:00:00',
        '11: Rotary 10sec. 0.08:00:00'
    ];
    // const optionsCol = ['FICA324-1.PV', 'Option 3','testValue', 'Option 2', 'Option 3','Option 1', 'Option 2', 'Option 3','Option 1', 'Option 2', 'Option 3','Option 1', 'Option 2', 'Option 3'];
    let optionsCol = [''];
    const [selectedValue, setSelectedValue] = useState<string | number>('');
    const [initialize, setInitialize] = React.useState(false);
    const [blockButtons, SetBlockButtons] = React.useState(false);

    const handleSelectChange = (value: string | number) => {
        setSelectedValue(value);
    };

    const [checked, setChecked] = React.useState(['']);

    const handleChecked = (item: any, check: boolean) => {
        let itemID = item.id;
        if (!check && checked.includes(item.id)) {
            const updatedChecked = checked.filter((item) => item !== itemID);
            setChecked(updatedChecked);
        } else {
            const updatedChecked = [...checked, itemID];
            setChecked(updatedChecked);
        }
        setData(TestData());
    };

    React.useEffect(() => {
        setData(TestData(initialize));
        // initialize = false;
        setInitialize(false);
    }, [checked]);

    const [inputValues, setInputValues] = React.useState<any[]>([]);

    const handleInputChange = (itemID: string, value: any, name?: string) => {
        if (checked.includes(itemID)) {
            if (name) {
                setInputValues((prevValues: any[]) => {
                    const existingObjIndex = prevValues.findIndex((obj) => obj.item === name);
                    if (existingObjIndex !== -1) {
                        const updatedArray = [...prevValues];
                        updatedArray[existingObjIndex] = { ...updatedArray[existingObjIndex], value };
                        return updatedArray;
                    } else {
                        return [...prevValues, { item: name, value }];
                    }
                });
            }
        }
    };

    const TestData = (initialize: boolean = false) => {
        let newChecked: any[] = [];

        let arrTest = props.group.map((param: any, index: number) => {
            if (!optionsCol.includes(param.name)) {
                optionsCol.push(param.name);
            }

            let block = <CentumSelect options={blockOpt} onChange={handleSelectChange} width={210} height={20} />;

            let collected = (
                <CentumSelect
                    value={param.name}
                    options={optionsCol}
                    onChange={handleSelectChange}
                    width={210}
                    height={20}
                />
            );

            // let SetUpperLower = (param.highlimit - param.lowlimit != 0);

            let lowlimit = param.lowlimit;
            let highlimit = param.highlimit;
            let check;

            checked.includes(index.toString()) ? (check = true) : (check = false);
            // param.checked ? param.checked = true : param.checked = false;

            let lower = (
                <CentumInput
                    name={param.lowlimitPath}
                    id={index.toString()}
                    value={lowlimit}
                    enable={check}
                    onChange={handleInputChange}
                    type={'text'}
                    width={130}
                    height={20}
                />
            );
            let upper = (
                <CentumInput
                    name={param.highlimitPath}
                    id={index.toString()}
                    value={highlimit}
                    enable={check}
                    onChange={handleInputChange}
                    type={'text'}
                    width={130}
                    height={20}
                />
            );

            return {
                ColNumber: ++index,
                Block: block,
                Collected: collected,
                Lower: lower,
                Upper: upper
            };
        });

        return arrTest;
    };

    React.useEffect(() => {
        const newChecked = props.group
            .map((param: any, index: any) => {
                if (!param.checked) {
                    return index.toString();
                }
                return '';
            })
            .filter(Boolean); // Удаление пустых строк
        setChecked(newChecked);
        setData(TestData());
    }, [props.group]);

    //Данные для теста таблицы
    const [data, setData] = React.useState(TestData());

    //OK Button
    function handleClickOK() {
        let checkdata = data;
        let EnableToSend: any[] = [];
        let PensToSend: any[] = [];

        props.group.map((param: any, index: number) => {
            let checkedPen = checked.includes(index.toString());
            if (checked.includes(index.toString())) {
                inputValues.map((Pen: any) => {
                    if (param.lowlimitPath == Pen.item || param.highlimitPath == Pen.item) {
                        PensToSend.push(Pen);

                        const highLimitEnable = EnableToSend.find(
                            (e) => e.item === `${param.highlimitPath}.SOURCEIN.Enable`
                        );
                        const lowLimitEnable = EnableToSend.find(
                            (e) => e.item === `${param.lowlimitPath}.SOURCEIN.Enable`
                        );

                        if (!highLimitEnable) {
                            EnableToSend.push({
                                item: `${param.highlimitPath}.SOURCEIN.Enable`,
                                value: `${!checkedPen}`
                            });
                        }

                        if (!lowLimitEnable) {
                            EnableToSend.push({
                                item: `${param.lowlimitPath}.SOURCEIN.Enable`,
                                value: `${!checkedPen}`
                            });
                        }
                    }
                });
            } else {
                EnableToSend.push(
                    {
                        item: `${param.highlimitPath}.SOURCEIN.Enable`,
                        value: `${!checkedPen}`
                    },
                    {
                        item: `${param.lowlimitPath}.SOURCEIN.Enable`,
                        value: `${!checkedPen}`
                    }
                );
            }
        });

        SetBlockButtons(true);

        SetParamBaseCentum(EnableToSend)
            .then(() => {
                SetParamBaseCentum(PensToSend).then(() => {
                    props.OnClose(true);
                    props.RefreshPen();
                });
            })
            .catch((error) => {
                console.error('Error setting parameters:', error);
            });
    }

    function handleClickCancel() {
        props.OnClose();
    }

    function handleClickInitialize() {
        let initialize = true;
        setInitialize(initialize);
        setData(TestData(initialize));
        setChecked(['']);
    }

    return (
        <PortableWindow
            parentID={props.parentID}
            width={900}
            height={510}
            Top={0}
            Left={0}
            title="Pen Assignment"
            OnClose={props.OnClose}>
            <div className="pen-assignment-main__tab" style={{ height: '5%' }}></div>
            <div className="pen-assignment-main__window" style={{ height: '85%' }}>
                <div className="pen-assigment-main__window__table" style={{ height: '90%' }}>
                    <Table
                        header={tableHeader}
                        data={data}
                        checked={checked}
                        onCheck={handleChecked}
                        width="100%"
                        height="100%"
                        paging={true}
                        cssClassBody="body__pentable"
                    />
                </div>
                <div style={{ height: '10%', display: 'flex', justifyContent: 'flex-end', margin: '0px 30px' }}>
                    <CentumButton
                        name={'Initialize'}
                        style={{ height: '30px', width: '80px' }}
                        onClick={handleClickInitialize}
                    />
                </div>
            </div>
            <div className="pen-assigment-main__buttons" style={{ height: '10%' }}>
                <div>
                    <CentumButton
                        name={'OK'}
                        disabled={blockButtons}
                        style={{ height: '30px', width: '80px' }}
                        onClick={handleClickOK}
                    />
                </div>
                <div>
                    <CentumButton
                        name={'Cancel'}
                        style={{ height: '30px', width: '80px' }}
                        onClick={handleClickCancel}
                    />
                </div>
            </div>
        </PortableWindow>
    );
}

export default PenAssigment;
